

/**
 * 埋点PropertyValue
 * bizType 业务类型 
 */
export const yqAnalyticsPropertyValueBizTypeByPagePath = {
	act: 'act', //活动
	'/t1.html': 't1', //获客内容底部菜单样式
	'/t2.html': 't2', //获客内容漂浮样式
	'/tp1.html': 'tp1', //神奇包裹
	t3: 't3', //很多客文章
	t4: 't4', //很多客楼盘信息
	t5: 't5', //很多宝创建页面
	t6: 't6', //很多客使用指南
	tp6: 'tp6', //筑巢3D沙盘
	t7: 't7', //楼盘信息
	t8: 't8', //很多客楼盘信息2
	t9: 't9', //售楼中心首页
	'/t10.html': 't10', //VR带看
	t11: 't11', //直播推广页面
	t12: 't12', //汽车详情页
	t13: 't13', //汽车销售中心首页
	'/tp100.html': 'tp100' //摩西游戏
}
/**
 * 获取埋点的基础数据
 */
export async function handlerGetYqAnalyticsPropertyValueBaseData() {

	let propertyValue = {
		// pageUrl 页面路径
		// pageQuery 页面参数
		// pageQueryScene 小程序码scene
		// pageTitle 页面标题
		// mpScene 启动小程序的场景值
		// adPushId 投放Id
		// appId
		// openId 
		// refereeopenid 上级传播者
		// rscuid 传播销售
		// projectId 项目Id
		// bizId 业务Id
		// bizType 业务类型 
		// gcj02 国家测量局02号标准坐标系统
	}
	return new Promise((resolve, reject) => {
		let waitingDataInterval = setInterval(() => {

			// pageUrl 页面路径
			propertyValue.pageUrl = location.pathname.substr(location.pathname.lastIndexOf("/"));

			// pageQuery 页面参数
			let urlParam = wj.getParamFromUrl(location.href);
			if (urlParam && Object.keys(urlParam).length > 0) {
				propertyValue.pageQuery = JSON.stringify(urlParam);
			}

			// pageTitle 页面标题
			propertyValue.pageTilte = window.document.title

			// appId
			if (wj.browser.versions.wx || myTemp.appid) {
				propertyValue.appId = myTemp.appid
				if (!propertyValue.appId) {
					return
				}
			}

			// openId 
			if (wj.browser.versions.wx || cfg.isLoc) {
				propertyValue.openId = myTemp.openid
				if (!propertyValue.openId) {
					return
				}
			}

			// refereeopenid 上级传播者
			if (myTemp.refereeopenid) {
				propertyValue.refereeopenid = myTemp.refereeopenid;
			}

			// rscuid 传播销售
			if (myTemp.rscuid) {
				propertyValue.rscuid = myTemp.rscuid
			}

			// projectId 项目Id
			if (myPageData.Pid) {
				propertyValue.projectId = myPageData.Pid;
			}

			// bizId 业务Id
			// bizType 业务类型
			if (yqAnalyticsPropertyValueBizTypeByPagePath[propertyValue.pageUrl]) {
				let bizId = '';
				let bizType = '';
				bizType = yqAnalyticsPropertyValueBizTypeByPagePath[propertyValue.pageUrl];
				bizId = myPageData.PageId;
				if (!bizId) {
					return;
				}
				propertyValue.bizId = bizId;
				propertyValue.bizType = bizType;
			}

			// gcj02 国家测量局02号标准坐标系统
			if (myTemp.gcj02) {
				propertyValue.gcj02 = JSON.stringify(myTemp.gcj02)
			}

			resolve(propertyValue);
			clearInterval(waitingDataInterval);
		}, 200)
	})
}

/**
 * 埋点事件
 */
export async function handlerYqAnalyticsEvent(eventId, propertyValue) {
	let propertyValueBaseData = await handlerGetYqAnalyticsPropertyValueBaseData();
	propertyValueBaseData = {
		...propertyValueBaseData,
		...propertyValue
	}
	yqAnalytics.triggerEvent({
		eventId,
		propertyValue: JSON.stringify(propertyValueBaseData)
	})
}